import {SubmitButton,Form,Link,QRText} from '../../styles/LoginStyle.js'

export default function QRHelp(props){
    return(
        <Form>
            <QRText>Common Authenticator Apps</QRText>
            <QRText className='marginBottom'>
                Mobile:
                &nbsp;
                <Link 
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US&gl=US" 
                    target="_blank" 
                    rel="noreferrer noopener">
                    Google Android
                </Link>,
                &nbsp;
                <Link 
                    href="https://apps.apple.com/us/app/google-authenticator/id388497605" 
                    target="_blank" 
                    rel="noreferrer noopener">
                    Google iOS
                </Link>,
                &nbsp;
                <Link 
                    href="https://www.microsoft.com/en-us/security/mobile-authenticator-app" 
                    rel="noreferrer noopener"
                    target="_blank">
                    Microsoft
                </Link>, 
                &nbsp;
                <Link 
                    href="https://authy.com/download" 
                    target="_blank" 
                    rel="noreferrer noopener">
                    Authy
                </Link>
            </QRText>
            <QRText className='marginBottom'>
                Desktop: 
                &nbsp;
                <Link 
                    href="https://authy.com/download" 
                    target="_blank" 
                    rel="noreferrer noopener">
                    Authy
                </Link>
            </QRText>
            <SubmitButton onClick={()=>{props.helpDone()}}>
                Okay
            </SubmitButton>
        </Form>
    )
}